<style lang="scss" src='./Activity.scss' scoped></style>
<template src="./Activity.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import Placeholder from '@/components/placeholders/Placeholders.vue';
import {
  getActivities,
  postActivities,
  editActivities
} from '@/api/index';
import i18n from './../../../../i18n';

import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';

export default {
  name: 'Activity',
  extends: SecurityComponent,
  components: {
    Placeholder,
  },
  data() {
    return {
      create: true,
      activitiesAvailable: [],
      newActive: false,
      editActivity: null,
      activityNameEnglish: null,
      activityNameSpanish: null,
      loading: false,
    };
  },
  computed: {
    orderedActivities() {
      if (this.activitiesAvailable && this.activitiesAvailable.length > 0) {
        let getName = this.getLabel;
        return this.activitiesAvailable.sort(function(a, b) {
          var nameA = getName(a).toUpperCase(); // ignore upper and lowercase
          var nameB = getName(b).toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }
    },
  },

  methods: {
    getLabel(item) {
      if(item.i18n.length > 0){
          let text = item.i18n.find((item)=>{
            if(item.language == this.$i18n.locale){
              return item
            }    
          })

          if(text){
            return text.i18n
          }else{
            return item.name
          }
        }else{
          return item.name
        }
    },

    showNewActivityModal() {
      this.newActive = true;
      this.activityNameSpanish = null;
      this.activityNameEnglish = null;
      this.$bvModal.show('modal-add-activity')
    },

    showEditActivityModal(item) {
      this.loading = false;
      this.editActivity = item;
      let itemSpanish = item.i18n.find((item) => item.language == 'es');
      this.activityNameSpanish = (itemSpanish) ? itemSpanish.i18n : '';
      let itemEnglish = item.i18n.find((item) => item.language == 'en');
      this.activityNameEnglish = (itemEnglish) ? itemEnglish.i18n : '';
      this.newActive = false;
      this.$bvModal.show('modal-add-activity');
    },
    
    copyName() {
      this.activityNameSpanish = this.activityNameEnglish
    },


    async saveActivity(){
      this.loading = true;
      if(this.activityNameSpanish && this.activityNameEnglish){

        let i18nArray =[
          { 
            language: "es",
            i18n: this.activityNameSpanish
          },{
            language: "en",
            i18n: this.activityNameEnglish
          }
        ]
        let data = {
          name: this.activityNameEnglish,
          i18n: i18nArray
        };

        if(this.newActive) {

          postActivities(data).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add-activity');
          })
        } else {
          editActivities(data, this.editActivity.activity_id).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add-activity');
          })
        }

        this.loading = false;
      }
    },

    async loadData() {
      this.loadAvailableAcivities();
    },

    loadAvailableAcivities() {
      getActivities().then((resp) => {
        if (resp.activities && resp.activities.length) {
          this.activitiesAvailable = resp.activities.map(activity => ({...activity, selected: false}));
        } else {
          this.activitiesAvailable = [];
        }
      })
    },
  },
  async mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings Activities");
      this.$analytics.logEvent("web_settings_activities");
    }

    this.loadData();
  },
};

</script>
